module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAAUCAYAAAB1c1lOAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gUJCTonrcKATgAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAqklEQVR42u3XoRFAYBiAYcxiB000heJ0mfo3Q7gTdDMYQhWMobDG5+55Rnjbm6dmfzPCuLtWhEDG5REhkHLYRAhkPiYRAumqS4RAzr4WIZCUVhECKSQAAAAMCAAAYEAAAAAMCAAAYEAAAAAMCAAAYEAAAAADAgAAYEAAAAADAgAAYEAAAAADAgAAGBAAAAADAgAAGBAAAAADAgAAGBAAAMCAAAAAAAAA/NkHYLUN0wXZv5IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/colour-bar.png
// module id = 539
// module chunks = 0